"use strict";

module.exports = function isValidName(name) {
    if (!name) return false;

    var urlPattern = /(http|https):\/\//i;
    var specialCharPattern = /[{}\[\]^:<>|\\/~]/;
    var digitPattern = /\d/;
    var unicodeDigitPattern = /[\u4e00-\u9fff]+/;
    var blacklistPattern = /(WB|Ð´Ð°Ñ€Ð¸Ñ‚|Ð¿Ð¾Ð´Ð°Ñ€ÐºÐ)/i;

    // ——— new “gibberish” patterns ———
    var vowelPattern            = /[aeiouAEIOU]/g;
    var consonantClusterPattern = /[^aeiouAEIOU]{5,}/;
    var uppercasePattern = /[A-Z]/g;
    var uppercaseCount   = (name.match(uppercasePattern) || []).length;

    // 1) too many consonants side‑by‑side?
    if (consonantClusterPattern.test(name)) {
        return false;
    }

    // 2) no vowels at all (and more than 3 chars long)
    var vowels = name.match(vowelPattern) || [];
    if (name.length > 3 && vowels.length === 0) {
        return false;
    }

    // 3) too many uppercase letters (and more than 3 chars long)?
    if (name.length > 3 && uppercaseCount > 2) {
        return false;
    }
    // —————————————————————————— end gibberish checks ——————————————————————————

    return !(
        urlPattern.test(name) ||
        specialCharPattern.test(name) ||
        digitPattern.test(name) ||
        name.length > 40 ||
        name.length < 2 ||
        blacklistPattern.test(name) ||
        unicodeDigitPattern.test(name)
    );
};
